'use strict';

import controller from './loading.controller';
import './loading.css';

const LoadingComponent = {
    template: `
        <div class="loading">Loading</div>
    `,
    controller
};

export default LoadingComponent;


// WEBPACK FOOTER //
// ./src/app/common/layout/loading/loading.component.js